import React from 'react'

const SvgScooter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M18.003 4a2 2 0 11-4 0 2 2 0 014 0zM7.83 12.234a1.352 1.352 0 01-.335-.764l-1.85 1.85-2.144-1.239a1 1 0 00-1 1.733l2.8 1.617a1 1 0 001.152-.107c.03-.024.06-.05.087-.078l2.097-2.097-.808-.915z' />
    <path d='M14.493 6.823a1.998 1.998 0 00-2.825 0l-2.641 2.64a1.998 1.998 0 00.057 2.881l1.904 1.904.034 3.907a.86.86 0 00.003.069H6.653a2.499 2.499 0 00-4.65 1.276 2.5 2.5 0 004.894.724h6.467a2 2 0 001.57-.762l2.924-3.705.29 1.642a2.5 2.5 0 101.973-.323l-.832-4.713a1 1 0 10-1.969.347l.075.426-4.026 5.088h-.643a.886.886 0 00.003-.084l-.037-4.282a.872.872 0 00-.005-.083.874.874 0 00-.255-.565l-.76-.76c.062-.05.122-.103.18-.16L14.48 9.66l.682.682a.998.998 0 00.72.294l2.987-.005a1 1 0 00-.003-2l-2.577.005-1.645-1.645a2.011 2.011 0 00-.151-.17z' />
  </svg>
)

export default SvgScooter
